import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { EmailProblemType, IEmailProblemSummary } from '../../entities/EmailProblem/EmailProblem';

export interface IEmailProblemStatus {
    hasEmailProblem: boolean;
    emailProblemType: EmailProblemType;
    email: string;
    shouldShowWarning: boolean;
}

export class EmailProblemsApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/EmailProblems`;

    public static apiUrls = {
        getEmailProblems: `${EmailProblemsApi.baseApiUrl}`,
        sendVerification: `${EmailProblemsApi.baseApiUrl}/:id/SendVerification`,
        getCurrentUserStatus: `${EmailProblemsApi.baseApiUrl}/current-user-status`,
        verifyEmail: `${EmailProblemsApi.baseApiUrl}/verify-email`,
    };

    public static async getEmailProblems(): Promise<IEmailProblemSummary[]> {
        return this.sendApiRequest<IEmailProblemSummary[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getEmailProblems,
        });
    }

    public static async sendVerification(id: number): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.sendVerification,
            id: id.toString(),
        });
    }

    public static async getCurrentUserEmailStatus(): Promise<IEmailProblemStatus> {
        return this.sendApiRequest<IEmailProblemStatus>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getCurrentUserStatus,
        });
    }

    public static async verifyEmail(token: string): Promise<{ success: boolean; message: string }> {
        return this.sendApiRequest<{ success: boolean; message: string }>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.verifyEmail,
            data: token,
            suppressGlobalErrorHandling: true
        });
    }
} 